import React, { useState, useEffect } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const EmployeeDaysAvailableScheduled = (
    {
        idScheduleSelected,
        idDaySelected,
        onUpdateIdDaySelected,
        resetFilterDay
    }) => {

    const [usersScheduledMonth, setUsersScheduledMonth] = useState(null);

    useEffect(() => {
        if (idScheduleSelected && idScheduleSelected.length == 1) {
            const fetchData = async () => {
                setUsersScheduledMonth(await getUsersScheduledMonth());
            };
            fetchData();
        }
    }, [idScheduleSelected]);


    useEffect(() => {
        if (!resetFilterDay) {
            return
        }

        if (idScheduleSelected && idScheduleSelected.length == 1) {
            const fetchData = async () => {
                setUsersScheduledMonth(await getUsersScheduledMonth());
            };
            fetchData();
        }
    }, [resetFilterDay]);

    async function getUsersScheduledMonth() {
        const parameters = {
            hash: idScheduleSelected[0]
        }

        const usersScheduledMonth = await ExecuteAxios.api('get', `/employee-hours-available/get-monthly-employee-planning/`, { params: parameters })
        RemoveIdsNotFound.remove(usersScheduledMonth, onUpdateIdDaySelected, idScheduleSelected)
        return usersScheduledMonth
    }

    return (
        <LoadingIndicator loaded={usersScheduledMonth}>
            <PanelListDefault
                onUpdateIdSelected={onUpdateIdDaySelected}
                idsSelected={idDaySelected}
                data={usersScheduledMonth}
            />
        </LoadingIndicator>
    )
};

export default EmployeeDaysAvailableScheduled;
